export const PLACEHOLDER_BASE64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAAGUlEQVR42mP8z8AARvEwYGBgkJGRAVYtFAAAMcwJrOLQqR4AAAAASUVORK5CYII=";

export const LOCATIONS = [
  "Toronto, ON",
  "Vancouver, BC",
  "Montreal, QC",
  "Calgary, AB",
  "Ottawa, ON",
];

export const DEVICE_IDS = [
  "ios-15pro-01",
  "ipad-m2-07",
  "macstudio-12",
  "pixel8-02",
  "device-unk-00",
];

// Agents (humans & AI)
export const HUMAN_AGENTS = [
  { id: "u-alex", name: "Alex M.", kind: "Human" as const },
  { id: "u-sam", name: "Sam K.", kind: "Human" as const },
  { id: "u-lee", name: "Lee P.", kind: "Human" as const },
];

export const AI_AGENTS = [
  { id: "ai-style", name: "StyleClassifier-v3", kind: "AI" as const },
  { id: "ai-ocr", name: "PaintingOCR-2", kind: "AI" as const },
  { id: "ai-match", name: "ImageMatcher-spg", kind: "AI" as const },
];

export const ALL_AGENTS = [...HUMAN_AGENTS, ...AI_AGENTS];

